import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class TransactionService {
  private api = inject(ApiService);

  remove(id: number) { return this.api.get(`/transaction/remove/${id}`); }
  refund(id: number) { return this.api.get(`/transaction/refund/${id}`); }
  getPaymentErrorData(studioId: number, yearMonth: string) {
    return this.api.get(`/invoice/payment_error/${studioId}/${yearMonth}`);
  }
  update(json: any) { return this.api.post('/transaction', json); }
  getStatus(json: any) { return this.api.post('/transaction/status', json); }
  async getBatchSchedule(): Promise<number> {
    const schedule: any = await this.api.get('/batchSchedule');
    const day = Number(typeof schedule === 'number' ? schedule : schedule?.createTransaction);
    return Number.isFinite(day) && day > 0 ? day : 11;
  }
}
